import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { IAnswerSafetyNet } from '../../Models';

interface IFaqWidgetProps {
    faq: IAnswerSafetyNet;
    isOpen: boolean;
    opinionLabel: string;
    opinionVotedLabel: string;
    onClick: (faq: IAnswerSafetyNet) => void;
    dictYes: string;
    dictNo: string;
    dictCommentSuccess: string;
    dictCommentFail: string;
    dictSend: string;
    dictCommentInvite: string;
    dictYourComment: string;
    contactUrl: string;
    contactString: string;
}

export class SafetyNetCardWidget extends Component<IFaqWidgetProps, any> {
    constructor(props: IFaqWidgetProps) {
        super(props);
    }

    handleClick = () => {
        if (this.props.onClick) {
            this.props.onClick(this.props.faq);
        }
    };

    render() {
        return (
            <li
                className={
                    'faq-item panel' + (this.props.isOpen ? ' open' : '')
                }
            >
                <div
                    className="faq-item--title accordion-title"
                    onClick={this.handleClick}
                >
                    <a
                        className="accordion-link securityNet-title"
                        data-toggle="accordion"
                        aria-expanded={this.props.isOpen}
                        aria-controls="collapseThree"
                        data-parent="#accordion"
                    >
                        <h4
                            dangerouslySetInnerHTML={{
                                __html:
                                    this.props.faq.title != undefined
                                        ? this.props.faq.title
                                        : '',
                            }}
                        ></h4>
                    </a>
                </div>
                <div className="accordion-body">
                    <article className="faq-item--content securityNet-content">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: this.props.faq.answer,
                            }}
                        ></span>
                    </article>
                </div>
            </li>
        );
    }
}

WidgetHelper.register(SafetyNetCardWidget, 'safety-net-card-widget');
